import { flag, int, oneOf, text, uuid } from '@/hooks/useUrlState';
import { TICKET_KIND_FILTER_LABELS, TICKET_SALE_CHANNEL_LABELS, TICKET_STATUS_FILTER_LABELS } from './adminTickets';

/** The /tickets query string, in this order (see README "List pages, URL state"). */
export const ticketsUrlSchema = {
  search: text(),
  status: oneOf(TICKET_STATUS_FILTER_LABELS, ''),
  kind: oneOf(TICKET_KIND_FILTER_LABELS, ''),
  channel: oneOf(TICKET_SALE_CHANNEL_LABELS, ''),
  night: uuid(),
  /** Only tickets that can still be claimed (purchased, not a door ticket): the night's Still unclaimed tile opens this. */
  unclaimed: flag(),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};
